import React, { useEffect, useState } from "react";
import NoLocationIcon from "../../../icons/NoLocationIcon";

import dynamic from "next/dynamic";
import { getMapLatitudeLongitude } from "services";
interface PDMapViewProps {
  isCoordinateFound: boolean;
  position: string[]; // Accepts an array of numbers or strings
  locality: {
    isFound: boolean;
    value: string | null;
  };
  city: any;
  state: any;
}
export default function PDMapView({
  isCoordinateFound,
  position,
  locality,
  city,
  state,
}: PDMapViewProps) {
  const Map = dynamic(() => import("./Map"), {
    loading: () => <p>Loading...</p>,
    ssr: false,
  });

  const [location, setLocation] = useState<any[]>([]);
  const [locationFound, setLocationFound] = useState(false);
  useEffect(() => {
    const fetchCoordinates = async (location: string) => {
      try {
        setLocationFound(false);
        const { latitude, longitude }: { latitude: any; longitude: any } =
          await getMapLatitudeLongitude(location);
        if (latitude && longitude) {
          setLocation([latitude, longitude]);
          setLocationFound(true);
          return [latitude, longitude];
        } else {
          console.log("latitude", latitude, "longitude", longitude);
          setLocationFound(false);
          return null;
        }
      } catch (err) {
        console.log("err: ", err);
        return null;
      }
    };

    const fetchLocation = async () => {
      if (!isCoordinateFound && locality.isFound && locality.value) {
        const primaryLocation = `${locality.value},${city.name}, ${state.name}, india`;
        const fallbackLocation = `${city.name}, ${state.name}, india`;
        const results = await Promise.allSettled([
          fetchCoordinates(primaryLocation),
          fetchCoordinates(fallbackLocation),
        ]);
        if (results[0].status === "fulfilled" && results[0].value) {
          setLocation(results[0].value);
          setLocationFound(true);
          return;
        }
        if (results[1].status === "fulfilled" && results[1].value) {
          setLocation(results[1].value);
          setLocationFound(true);
          return;
        } else {
          setLocationFound(false);
        }
      }
    };

    fetchLocation();
  }, [locality]);

  return (
    <div className="mt-14 lg:mt-11">
      <h3 className="font-openSans text-brand-textBlack">Map View</h3>
      {isCoordinateFound || locationFound ? (
        <div className="text-center my-5 lg:my-6 lg:px-6 flex justify-center lg:justify-start">
          <Map position={isCoordinateFound ? position : location} zoom={13.5} />
        </div>
      ) : (
        <div className="h-[320px] xl:h-[411px] flex justify-center items-center bg-[#F9F9F9] mt-5 ">
          <div className="flex flex-col justify-center items-center">
            <NoLocationIcon />
            <p className="mt-10 text-sm text-brand-textBlack font-openSans">
              Location data is temporarily unavailable.{" "}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
